module.exports = __webpack_public_path__ + "img/Logo_Gopay.svg.2ae12f92.png";